import React, { useState } from 'react';
import { TextField } from '@material-ui/core';
import { useField } from 'react-final-form-hooks';
import { SketchPicker } from 'react-color';

import _ from 'lodash';

export default function ({
  form,
  name,
  label,
  icon,
  margin = 'normal',
  type = 'text',
  children,
  hint,
  hidden,
  onChange,
  ...props
}) {
  const [openPicker, setOpenPicker] = useState(false);
  const field = useField(name, form);
  const _onChange = (event) => {
    if (_.isFunction(onChange)) onChange(event);
    if (type === 'number') {
      if (event.target.value === '' || _.isNil(event.target.value))
        return field.input.onChange('');

      return field.input.onChange(Number(event.target.value));
    }
    field.input.onChange(event);
  };

  if (hidden) {
    return null;
  }

  return (
    <div class="flex-row flex-fill">
      <TextField
        {...field.input}
        onChange={_onChange}
        value={field.input.value || ''}
        margin={margin}
        label={label}
        fullWidth
        type={type}
        size="small"
        variant="outlined"
        error={!!field.meta.touched && !!field.meta.error}
        helperText={field.meta.touched ? field.meta.error : null}
        {...props}
      />
      <button
        type="button"
        className="width-50 MuiFormControl-marginNormal ml-2 border p1"
        onClick={() => setOpenPicker(true)}
      >
        <div
          className="fullwidth"
          style={{ backgroundColor: field.input.value, height: '24px' }}
        />
      </button>
      {openPicker && <div className="position-fixed fullheight fullwidth top left" onClick={() => setOpenPicker(false)}></div>}
      {openPicker && (
        <div className="position-absolute right" style={{ zIndex: 2, top: '100%' }}>
          <SketchPicker
            disableAlpha
            color={field.input.value ? field.input.value : undefined}
            onChangeComplete={(value) => _onChange(value ? value.hex : '')}
          />
        </div>
      )}
    </div>
  );
}
